'use client';
import type { Country } from '@/helpers/conf';
import { useGetCommonStore } from '@/store';

export const useCurrentCountry = (country: Country) => {
  const useCommonStore = useGetCommonStore();
  const countryCode = useCommonStore.use.countryCode();

  return countryCode === country;
};
